import { SocialPerson } from '@/models/Person';
import { Reducer } from 'redux';
import _ from 'underscore';
import { FollowersState, FollowerTypes, OnlyFollowersList } from './types';

const INITIAL_STATE: FollowersState = {
    data: {
        followers: [],
        following: [],
        totalFollowers: 0,
        totalFollowing: 0,
        immutableTotalFollowing: 0,
    },
    hasError: false,
    loading: false,
};

const processRequestSuccess = (state: FollowersState, payloadList: SocialPerson[], total: number, propListName: string, propTotalName: string) => {
    const currentList: SocialPerson[] = [...state.data[propListName as keyof OnlyFollowersList]];
    const mergedList: SocialPerson[] = currentList.concat(payloadList);
    const resultList: SocialPerson[] = (_.chain(mergedList)
        .filter((person: SocialPerson) => Boolean(person.id))
        .uniq(false, (person: SocialPerson) => person.id)
        .value() as unknown) as SocialPerson[];

    return {
        ...state,
        loading: false,
        hasError: false,
        data: {
            ...state.data,
            [propListName]: resultList,
            [propTotalName]: currentList.length === 0 ? total : state.data[propTotalName as keyof OnlyFollowersList],
            immutableTotalFollowing: propListName === 'following' ? total : state.data.immutableTotalFollowing,
        },
    };
};

const reducer: Reducer<FollowersState> = (state: FollowersState = INITIAL_STATE, action) => {
    switch (action.type) {
        case FollowerTypes.GET_FOLLOWERS_REQUEST:
        case FollowerTypes.GET_FOLLOWING_REQUEST:
            return { ...state, loading: true };
        case FollowerTypes.GET_FOLLOWERS_SUCCESS:
            const { followers, total: totalFollowers } = action.payload;
            return processRequestSuccess(state, followers, totalFollowers, 'followers', 'totalFollowers');
        case FollowerTypes.GET_FOLLOWERS_FAILURE:
        case FollowerTypes.SET_FOLLOWER_FAILURE:
        case FollowerTypes.DELETE_FOLLOWER_FAILURE:
        case FollowerTypes.GET_FOLLOWING_FAILURE:
        case FollowerTypes.BATCH_FOLLOW_FAILURE:
            return { ...state, loading: false, hasError: true };
        case FollowerTypes.GET_FOLLOWING_SUCCESS:
            const { following, total: totalFollowing } = action.payload;
            return processRequestSuccess(state, following, totalFollowing, 'following', 'totalFollowing');
        case FollowerTypes.SET_FOLLOWER_SUCCESS:
        case FollowerTypes.DELETE_FOLLOWER_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
            };
        case FollowerTypes.CLEAR_FOLLOWERS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, followers: [] },
            };
        case FollowerTypes.CLEAR_TOTAL_FOLLOWERS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, totalFollowers: 0 },
            };
        case FollowerTypes.CLEAR_FOLLOWING:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, following: [] },
            };
        case FollowerTypes.INCREASE_FOLLOWING:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, totalFollowing: action.payload ? state.data.totalFollowing + 1 : state.data.totalFollowing },
            };
        case FollowerTypes.DECREASE_FOLLOWING:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, totalFollowing: action.payload ? state.data.totalFollowing - 1 : state.data.totalFollowing },
            };
        case FollowerTypes.BATCH_FOLLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                hasError: false,
            };
        default:
            return state;
    }
};

export default reducer;
